import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useState } from "react";
import Select from "../../../features/ARR/components/shared/Select";
import { URL } from "../../../utils/Constants";
import { axiosPost } from "../../../utils/AxiosApi";
import { Slider } from "@mui/material";

const FilterModal = ({
  filterData,
  filterModal,
  setFilterData,
  setFilterModal,
  getAllTeachers,
}) => {
  const [assessmentOptions, setAssessmentOptions] = useState([]);
  const [educationLevelOptions, setEducationLevelOptions] = useState([]);

  const getEducationLevel = () => {
    axiosPost(URL.getARRModules, {}, (response) => {
      if (response?.status === 200) {
        const result = response?.data.data;
        const processedData = result?.map((item) => ({
          label: item.name,
          value: item.code,
        }));
        setEducationLevelOptions(processedData);
      }
    });
  };

  const handleFilter = () => {
    getAllTeachers();
  };

  const getAllAssessments = (educationLevelId) => {
    axiosPost(
      URL.selectAssessments,
      { assessmentModuleCode: educationLevelId, offset: 0, limit: null },
      (response) => {
        if (response?.status === 200) {
          const results = response?.data?.data;
          const processedData = (results || [])?.map((item) => ({
            label: item?.assessmentName,
            value: item?.id,
          }));
          setAssessmentOptions(processedData);
        }
      },
    );
  };

  const handleFilterData = (name, value) => {
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    getEducationLevel();
  }, []);

  return (
    <aside className={`filterModal ${filterModal ? "show" : ""}`}>
      <div className="flex" style={{ justifyContent: "space-between" }}>
        <h3>Filter</h3>
        <button className="ghost-btn" onClick={() => setFilterModal(false)}>
          <FontAwesomeIcon icon={faXmark} fontSize={16} />
        </button>
      </div>

      <div
        style={{
          marginTop: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        <div className="form-input">
          <label htmlFor="">Education Level</label>

          <Select
            options={educationLevelOptions}
            value={
              educationLevelOptions?.find(
                (opt) => opt?.value === filterData?.educationLevelId,
              ) || null
            }
            onChange={(option) => {
              handleFilterData("educationLevelId", option?.value);
              setFilterData((prev) => ({ ...prev, assessmentId: "" }));
              getAllAssessments(option?.value);
            }}
            placeholder={"Select Education Level"}
          />
        </div>

        <div className="form-input">
          <label htmlFor="">Assessments</label>
          <Select
            options={assessmentOptions}
            value={
              assessmentOptions?.find(
                (opt) => opt?.value === filterData?.assessmentId,
              ) || null
            }
            onChange={(option) =>
              handleFilterData("assessmentId", option?.value)
            }
            placeholder={"Select Assessment"}
            isDisabled={!filterData?.educationLevelId}
          />
        </div>
{/* 
        <div className="form-input">
          <label htmlFor="">Participants</label>
          <Slider
            name="participants"
            getAriaLabel={() => "participants range"}
            valueLabelDisplay="auto"
            value={filterData?.participants}
            onChange={(e) => {
              const value = e.target.value;
              handleFilterData("participants", value);
            }}
          />
        </div>

        <div className="form-input">
          <label htmlFor="">Pass Rate</label>
          <Slider
            name="passrate"
            getAriaLabel={() => "pass rate"}
            valueLabelDisplay="auto"
            value={filterData?.passrate}
            onChange={(e) => {
              const value = e.target.value;
              handleFilterData("passrate", value);
            }}
          />
        </div>

        <div className="form-input">
          <label htmlFor="">Average Marks</label>
          <input
            type="number"
            className="form-control"
            name="avgMarks"
            value={filterData?.avgMarks}
            onChange={(e) => {
              const value = e.target.value;
              handleFilterData("avgMarks", value);
            }}
          />
        </div>

        <div className="form-input">
          <label htmlFor="">Average Score</label>
          <Slider
            name="avgScore"
            getAriaLabel={() => "avgScore"}
            valueLabelDisplay="auto"
            value={filterData?.avgScore}
            onChange={(e) => {
              const value = e.target.value;
              handleFilterData("avgScore", value);
            }}
          />
        </div> */}

        <button
          onClick={handleFilter}
          className="primary-btn"
          style={{ width: "100%" }}
        >
          Submit
        </button>
      </div>
    </aside>
  );
};

export default FilterModal;
